import axiosAuth from '../../axios/auth';
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API

import router from '../../router/router';
import { routes } from '../../router/routes';
import { store } from '../store';
// resources:
//  https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507
//  https://stackoverflow.com/questions/46234832/structuring-a-vuex-module

// indexDB reference: https://developers.google.com/web/ilt/pwa/lab-indexeddb
import idb from 'idb';

const state = {

    msgsCached : JSON.parse( localStorage.getItem( 'msgsCached' ) ) || null,
    inAppMsgs  : [],
    currentMsg : JSON.parse( localStorage.getItem( 'currentMsg' ) ) || null
};

const mutations = {

    setMsgs( state, data ){

        // console.log( 'data coming through..', data );
        if( data.body.length > 0 ){

            let dbPromise = idb.open( 'quickOrdersDB', data.idbVerison );
            dbPromise.then( db => {

                var txInAppMsgs;
                try {
                    txInAppMsgs = db.transaction( 'inAppMsgs', 'readwrite' );
                } catch( e ) {
                    store.dispatch( 'fixMissingObjectStore', e );
                }

                data.body.forEach( value => {

                    // console.log( 'msg data: ', value );
                    txInAppMsgs.objectStore( 'inAppMsgs' ).put( value );
                    state.inAppMsgs.push( value );
                });
            });
        }
        const timestamp = parseInt( new Date().getTime() );
        state.msgsCached = timestamp;
        localStorage.setItem( 'msgsCached', timestamp );
    },
    toggleCache( state ){ // not up to date with the new timestamp-cache strategy, DO NOT USE UNLESS UPDATED

        console.log( 'old cache: ', state.msgsCached );
        state.msgsCached = !state.msgsCached;
        console.log( 'new cache: ', state.msgsCached );
        localStorage.setItem( 'msgsCached', state.msgsCached );
    },
    viewMsg( state, msgId ){

        localStorage.setItem( 'currentMsg', msgId );
        state.currentMsg = msgId;
    },
    clearState( state ){

        state.inAppMsgs = [];

        state.msgsCached = null;
        localStorage.removeItem( 'msgsCached' );

        state.currentMsg = null;
        localStorage.removeItem( 'currentMsg' );
    }
};

const actions = {

    getMsgs( { commit, getters, rootGetters } ){

        if( getters.msgsCached == null || parseInt( getters.msgsCached ) + parseInt( 5 * 60 * 1000 ) < parseInt( new Date().getTime() ) ){

            axiosAuth({

                method: 'post',
                url: '/getMessages',
                data: '',
                headers: {

                    'Content-Type' : 'application/x-www-form-urlencoded',
                    'AuthType'     : 'JWT',
                    'ApiKey'       : process.env.VUE_APP_API_KEY,
                    'Token'        : localStorage.getItem( 'token' ) || null
                }
            }).then( res => {

                // console.log( 'result: ', res.data );
                if( res.data.responseCode == 100 ){

                    // run a diff
                    if( getters.inAppMsgs.length > 0 ){ // we have some currently loaded

                        res.data.body.forEach( ( msg, key ) => {

                            for( let i = 0; i < getters.inAppMsgs.length; i++ ){

                                if( msg.Message.messageId == getters.inAppMsgs[ i ].Message.messageId ){

                                    res.data.body[ key ].alreadyExists = true;
                                    break;
                                }
                            }
                        });

                        const newMsgs = res.data.body.filter( msg => !msg.alreadyExists );
                        const payload = {

                            body       : newMsgs, // only push the new ones not previously seen
                            idbVersion : rootGetters[ 'idbVersion' ]
                        };
                        commit( 'setMsgs', payload );
                    } else {

                        const payload = {

                            body       : res.data.body,
                            idbVersion : rootGetters[ 'idbVersion' ]
                        };
                        commit( 'setMsgs', payload );
                    }
                } else {

                    console.log( "server error!" );
                }
            }).catch( err => {

                console.error( 'error! ', err );
            });
        }
    },
    toggleCache( { commit } ){

        commit( 'toggleCache' );
    },
    openMsg( { commit, rootGetters }, msg ){

        commit( 'viewMsg', msg.Message.messageId );
        router.push({

            name: 'view-msg',
            params : { slug : rootGetters[ 'merchant/merchantSlug' ] }
        });
    },
    clearState( { commit } ){

        commit( 'clearState' );
    }
};

const getters = {

    msgsCached : state => state.msgsCached,
    inAppMsgs  : state => state.inAppMsgs,
    currentMsg( state ){

        return state.inAppMsgs.filter( msg => {

            if( msg.Message.messageId == state.currentMsg ) return msg;
        })[ 0 ];
    }
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};